<template>
    <el-dialog custom-class="validate_dialog" :model-value="show" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-bianji"></i></div>
            <h1>新建收藏夹</h1>
            <h2>请命名收藏夹，6个字以内</h2>
            <AnimationInput v-model="favoriteName" maxlength="6" name="favoriteName" placeholder="收藏夹名" :autoFocus="true" />
            <div class="btn_box" v-loading="loading">
                <button @click="submit">保存</button>
                <button @click="handleClose">取消</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import AnimationInput from "@/components/common/AnimationInput.vue";
import { Close } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { apiFavoriteSave } from "@/request/api";

const props = defineProps({
    show: { type: Boolean, default: false },
});
const emits = defineEmits(["close", "success"]);

const favoriteName = ref("");
const loading = ref(false);

async function submit() {
    if (!favoriteName.value) {
        ElMessage.error("请输入收藏夹名称");
        return;
    }
    loading.value = true;
    try {
        const { code } = await apiFavoriteSave({ favoriteName: favoriteName.value });
        if (code !== "0") return;
        handleClose();
        emits("success");
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    favoriteName.value = "";
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.validate_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            margin-bottom: 16px;
            span {
                color: #2a2a2a;
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
